// extracted by mini-css-extract-plugin
export default {"link":"UserMobileTable_link__NKrQd","chatIcon":"UserMobileTable_chatIcon__OIgsv","table":"UserMobileTable_table__Lrjhe","more":"UserMobileTable_more__j6SvQ"};